import React from 'react';
import { useTranslation } from 'react-i18next';

import { useAnimateInRef } from '../../../utils/hooks';
import Layout from './Layout';

import * as styles from './Error.module.scss';

import wiLightningIcon from '../svg/wi-lightning.svg';

const Error = (): React.ReactElement => {
  const { t } = useTranslation();
  return (
    <Layout>
      <div className={styles.error}>
        <img
          ref={useAnimateInRef(styles.animateIn, 100)}
          className={styles.image}
          src={wiLightningIcon}
        ></img>
        <span ref={useAnimateInRef(styles.animateIn, 150)}>
          {t('weather_widget.error_text_1', 'Could not fetch weather data.')}
        </span>
        <br />
        <span ref={useAnimateInRef(styles.animateIn, 200)}>
          {t('weather_widget.error_text_2', 'Please try again later.')}
        </span>
      </div>
    </Layout>
  );
};

export default Error;
